import React, { useEffect } from "react";
import {
  Flex,
  Grid,
  GridItem,
  Heading,
  Text,
  Tooltip,
  Icon,
  IconButton,
  Image,
  Button,
} from "@chakra-ui/react";
import { textSecondary, white, primaryAlt } from "../../../../../utils/colors";
import dayjs from "dayjs";
import {
  TbDeviceMobileStar,
  TbDeviceMobile,
  TbMail,
  TbGenderAndrogyne,
  TbMapPin,
  TbCalendar,
  TbFingerprint,
  TbBuildingSkyscraper,
  TbEdit,
} from "react-icons/tb";
import { useTranslation } from "react-i18next";
// import SidePanel from "../../../../../components/sidepanel/SidePanel";
// import EditPatientNew from "../../sidepanels/EditPatientNew";
import useRoleCheck from "../../../../../hooks/useRoleCheck";
import blank from "../../../../../assets/icons/blank.svg";
import useThemeColors from "../../../../../hooks/useThemeColors";
import UserNoAccess from "../../../../../components/partials/UserNoAccess";

const PatientDetails = ({ slug, tenant, userInfo, user, openEdit }) => {
  const { t } = useTranslation();

  const { backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  // ROLES
  const isDoctor = false;
  // const isAdmin = useRoleCheck("admin");

  // console.log("user in patient details", user

  return (
    <>
      <Flex w="100%" direction="column" m="0rem 0 ">
        <Flex align="baseline" justify="space-between" m="0 0 0rem">
          <Heading
            fontSize="1.125rem"
            color={textPrimaryMode}
            fontWeight="600"
            m={0}
            // p="0 0 0.75rem"
          >
            {t("patient.details")}
          </Heading>

          <Flex align="center" justify="flex-end" gap="0.5rem">
            <Button
              size="md"
              fontSize="sm"
              // borderRadius="1rem"
              borderRadius="10rem"
              bg={backgroundLightMode}
              border={`1px solid ${backgroundLightMode}`}
              color={textSecondary}
              // p="0.5rem 1rem"
              onClick={openEdit}
              _hover={{ bg: primaryAlt, color: white, border: primaryAlt }}
            >
              <Flex align="center">
                <Icon as={TbEdit} fontSize="0.875rem" mr={1} />
                <Text>{t("button.edit")}</Text>
              </Flex>
            </Button>{" "}
          </Flex>
        </Flex>

        <Grid
          templateColumns="repeat(3, 1fr)"
          gap={8}
          w="100%"
          m="0.5rem 0 0"
          p="2rem 1.5rem"
          pr="20%"
          border={`1px solid ${newBorderMode}`}
          borderRadius="1rem"
          position="relative"
        >
          <GridItem colSpan={1}>
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsPhone")}:
                    </Text>

                    <Text color={white} fontWeight="500" ml={1}>
                      {user && user.phone ? user.phone : "-"}
                    </Text>
                  </Flex>
                )
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbDeviceMobileStar}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <Text
                    color={textSecondary}
                    fontSize="sm"
                    fontWeight="500"
                    lineHeight="1.2"
                  >
                    {user && user.phone ? user.phone : "-"}
                  </Text>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsPhoneAlternative")}:
                    </Text>
                    <Text color={white} fontWeight="500" ml={1}>
                      {user && user.phoneAlt ? user.phoneAlt : "-"}
                    </Text>
                  </Flex>
                )
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbDeviceMobile}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <Text
                    color={textSecondary}
                    fontSize="sm"
                    fontWeight="500"
                    lineHeight="1.2"
                  >
                    {user && user.phoneAlt ? user.phoneAlt : "-"}
                  </Text>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsEmail")}:
                    </Text>

                    <Text color={white} fontWeight="500" ml={1}>
                      {user && user.email ? user.email : "-"}
                    </Text>

                    {/* <Image src={blank} size="sm" /> */}
                  </Flex>
                )
              }
            >
              <Flex align="center">
                <Icon
                  as={TbMail}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <Text
                    color={textSecondary}
                    fontSize="sm"
                    fontWeight="500"
                    lineHeight="1.2"
                    maxWidth="140px"
                    isTruncated
                  >
                    {user && user.email ? user.email : "-"}
                  </Text>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>
          </GridItem>
          <GridItem colSpan={1}>
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                <Flex align="center">
                  <Text color={white} fontWeight="400">
                    {t("patient.detailsGender")}:
                  </Text>
                  <Text color={white} fontWeight="500" ml={1}>
                    {user && user.gender
                      ? user.gender === "male"
                        ? t("patient.detailsGenderMale")
                        : user.gender === "female"
                        ? t("patient.detailsGenderFemale")
                        : t("patient.detailsGenderOther")
                      : "-"}
                  </Text>
                </Flex>
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbGenderAndrogyne}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                <Text
                  color={textSecondary}
                  fontSize="sm"
                  fontWeight="500"
                  lineHeight="1.2"
                >
                  {user && user.gender
                    ? user.gender === "male"
                      ? t("patient.detailsGenderMale")
                      : user.gender === "female"
                      ? t("patient.detailsGenderFemale")
                      : t("patient.detailsGenderOther")
                    : "-"}
                </Text>
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                <Flex align="center">
                  <Text color={white} fontWeight="400">
                    {t("patient.detailsPersonalCode")}:
                  </Text>
                  <Text color={white} fontWeight="500" ml={1}>
                    {user && user.personalCode ? user.personalCode : "-"}
                  </Text>
                </Flex>
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbFingerprint}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                <Text
                  color={textSecondary}
                  fontSize="sm"
                  fontWeight="500"
                  lineHeight="1.2"
                >
                  {user && user.personalCode ? user.personalCode : "-"}
                </Text>
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                <Flex align="center">
                  <Text color={white} fontWeight="400">
                    {t("patient.detailsBirthdate")}:
                  </Text>
                  <Text
                    color={white}
                    fontWeight="500"
                    ml={1}
                    textTransform="capitalize"
                  >
                    {(user.birthDate &&
                      dayjs(user.birthDate).format("YYYY MMMM D")) ||
                      "-"}
                  </Text>
                </Flex>
              }
            >
              <Flex align="center">
                <Icon
                  as={TbCalendar}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                <Text
                  color={textSecondary}
                  fontSize="sm"
                  fontWeight="500"
                  whiteSpace="nowrap"
                >
                  {(user.birthDate &&
                    dayjs(user.birthDate).format("YYYY MMMM DD")) ||
                    "-"}
                </Text>
              </Flex>
            </Tooltip>
          </GridItem>

          <GridItem colSpan={1}>
            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsAddress")}:
                    </Text>
                    <Text
                      color={white}
                      fontWeight="500"
                      ml={1}
                      whiteSpace="nowrap"
                    >
                      {user && user.address.length > 0
                        ? user.address[0].street
                        : "-"}
                    </Text>
                  </Flex>
                )
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbMapPin}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <Text
                    color={textSecondary}
                    fontSize="sm"
                    fontWeight="500"
                    lineHeight="1.2"
                    whiteSpace="nowrap"
                  >
                    {user && user.address.length > 0
                      ? user.address[0].street
                      : "-"}
                  </Text>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsCity")}:
                    </Text>

                    <Flex align="center">
                      <Text color={white} fontWeight="500" ml={1}>
                        {user && user.address.length > 0
                          ? user.address[0].city
                          : "-"}
                        ,
                      </Text>
                      <Text color={white} fontWeight="500" ml={1}>
                        {user && user.address.length > 0
                          ? user.address[0].zip
                          : "-"}
                      </Text>
                    </Flex>
                  </Flex>
                )
              }
            >
              <Flex align="center" mb={4}>
                <Icon
                  as={TbBuildingSkyscraper}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <>
                    <Text
                      color={textSecondary}
                      fontSize="sm"
                      fontWeight="500"
                      lineHeight="1.2"
                      whiteSpace="nowrap"
                      maxWidth="140px"
                      isTruncated
                    >
                      {user && user.address.length > 0
                        ? user.address[0].city
                        : "-"}
                      ,
                      <Text
                        as="span"
                        color={textSecondary}
                        fontSize="sm"
                        fontWeight="500"
                        lineHeight="1.2"
                        ml={1}
                      >
                        {user && user.address.length > 0
                          ? user.address[0].zip
                          : "-"}
                      </Text>
                    </Text>
                  </>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>

            <Tooltip
              p="0.5rem 1rem"
              borderRadius="1rem"
              placement="top-start"
              fontSize="0.8rem"
              label={
                !isDoctor && (
                  <Flex align="center">
                    <Text color={white} fontWeight="400">
                      {t("patient.detailsCountry")}:
                    </Text>
                    <Text color={white} fontWeight="500" ml={1}>
                      {user && user.address.length > 0
                        ? user.address[0].country
                        : "-"}
                    </Text>
                  </Flex>
                )
              }
            >
              <Flex align="center">
                <Icon
                  as={TbMapPin}
                  h="1.25rem"
                  w="1.25rem"
                  color={textSecondary}
                  mr={2}
                />
                {!isDoctor ? (
                  <Text color={textSecondary} fontSize="sm" fontWeight="500">
                    {user && user.address.length > 0
                      ? user.address[0].country
                      : "-"}
                  </Text>
                ) : (
                  <Image src={blank} size="sm" />
                )}
              </Flex>
            </Tooltip>
          </GridItem>
        </Grid>
      </Flex>
    </>
  );
};

export default PatientDetails;
